import {
    ListarTelasVinculadasPorGrupoService,
    ListarTelasDesvinculadasPorGrupoService,
    VincularTelaGrupoService,
    DesvincularTelaGrupoService,
} from "../../../Services/Geral/Grupos/GrupoTelaService";
import { vincularGrupo } from "../../../Interfaces/Geral/Grupos/GruposTelasInterface";
import { Controller } from "../../Controller";

export async function VincularTelaGrupoController(
    requestBody: vincularGrupo[]
) {
    return Controller(VincularTelaGrupoService(requestBody));
}

export async function DesvincularTelaGrupoController(idTelaGrupo: number[]) {
    return Controller(DesvincularTelaGrupoService(idTelaGrupo));
}

export async function ListarTelasPorGrupoController(idGrupo: number) {
    return Controller(ListarTelasVinculadasPorGrupoService(idGrupo));
}

export async function ListarTelasDesvinculadasPorGrupoController(
    idGrupo: number
) {
    return Controller(ListarTelasDesvinculadasPorGrupoService(idGrupo));
}
